import { render, staticRenderFns } from "./NewEditHedgeCurrencies.vue?vue&type=template&id=0124fcfc&"
import script from "./NewEditHedgeCurrencies.vue?vue&type=script&lang=js&"
export * from "./NewEditHedgeCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports